import React from "react";
import "../style/header.css";


function Header(){
    return (
        <div className="header"> This is a Chess Board  using props , map </div>
    )
}

export default Header;